/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function DiffRemoved({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}><path fill="currentColor" d="M11.668 1.165c.644 0 1.167.523 1.167 1.167v9.336c0 .644-.523 1.167-1.167 1.167H2.332a1.167 1.167 0 0 1-1.167-1.167V2.332c0-.644.522-1.167 1.167-1.167zM3.482 6.359a.6.6 0 0 0 0 1.2h6.953a.6.6 0 1 0 0-1.2z" /></svg>;
}
;